module.exports = __webpack_public_path__ + "static/media/drop-off.013f81af.svg";